export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        pickup_visible: {
          label: 'Levantamento visível',
        },
        has_pickup: {
          label: 'Levantamento',
        },
      },
    },
    scheduled_orders: {
      title: 'Encomendas agendadas',
      fields: {
        has_scheduled_orders: {
          label: 'Permite que os clientes encomendem com antecedência para horas específicas?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Tempo mínimo (minutos) de antecedência para agendar encomendas de <strong>levantamento</strong>',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Última hora para encomendar <strong>levantamento</strong> (minutos antes do fecho)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Tempo de preparação para encomendas de levantamento',
      fields: {
        average_order_preparation_time_min: {
          label: 'Tempo de preparação em minutos',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'até',
          placeholder: 'Opcional',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    at_least_one_order_method_required:
      'É necessário ter pelo menos 1 método de encomenda (agendado ou imediato) ativo. Não pode desativar ambos.',
  },
};
